import { Alert, Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import CarbonNeutralityRemark, {
  CARBON_REMARK_ID,
} from './CarbonNeutralityRemark';
import CarbonNeutralityDetail from './CarbonNeutralityDetail';

const CarbonNeutrality = () => {
  return (
    <Box width={'100%'} mt={2}>
      <Flex gap={1} alignItems={'center'}>
        <Typography fontWeight={'bold'}>
          การตั้งเป้าหมายความเป็นกลางทางคาร์บอน (Carbon Neutrality)​
        </Typography>
        <CarbonNeutralityRemark />
      </Flex>
      <Alert severity="info" sx={{ mt: 2 }}>
        คำชี้แจง : กรุณาระบุรายละเอียดการตั้งเป้าหมาย
        โดยสามารถเพิ่มเป้าหมายได้หลายข้อ
      </Alert>
      <CarbonNeutralityDetail />
      <Box id={CARBON_REMARK_ID} />
    </Box>
  );
};

export default CarbonNeutrality;
